import { Box, Divider, Typography, useMediaQuery, useTheme } from '@mui/material';
import { NoticiaList } from '../../../../typesSite/noticia/Noticia';
import { useGetNoticiasPublicQuery, useGetUltimasNoticiasPublicQuery } from '../noticia/noticiaPublicApiSlice';
import { useEffect, useState } from 'react';
import { enqueueSnackbar } from 'notistack';
import formatErrorMessage from '../../../../utils/errorFormat';
import { NoticiaViewCarrossel } from './NoticiaViewCarrossel';
import NoticiaPublicCardForm from '../noticia/listPublic/NoticiaPublicCardForm';
import NoticiaHomeCardForm from './NoticiaHomeCardForm';
import { PublicacaoOficialList } from '../publicacaoOficial/types/PublicacaoOficial';
import { useGetUltimasPublicacoesPublicQuery } from '../publicacaoOficial/publicaoOficialAnexoApiSlice';
import PublicacaoOficialHomeCardForm from './PublicacaoOficialHomeCardForm';
import { useGetUltimasLicitacoesPublicQuery } from '../licitacao/create/licitacaoApiSlice';
import { LicitacaoList } from '../licitacao/types/Licitacao';
import LicitacaoHomeCardForm from './LicitacaoHomeCardForm';

export default function SiteHome() {
  const theme = useTheme();
  const [noticias, setNoticias] = useState<NoticiaList[]>([]);
  const [ultimasNoticias, setUltimasNoticias] = useState<NoticiaList[]>([]);
  const [ultimasPublicacoes, setUltimasPublicacoes] = useState<PublicacaoOficialList[]>([]);
  const [ultimasLicitacoes, setUltimasLicitacoes] = useState<LicitacaoList[]>([]);

  const { data, isFetching, isLoading, error } = useGetUltimasNoticiasPublicQuery();
  // Atualiza estado com os dados retornados
  useEffect(() => {
    if (!data) return;
    setNoticias(data.results);
    setUltimasNoticias(data.noticiaCardForm);
  }, [data]);

  // Erro ao carregar
  useEffect(() => {
    if (error) {
      enqueueSnackbar('Erro ao carregar as notícias.', { variant: 'error' });
      const erroReturn: string = formatErrorMessage(error);
      enqueueSnackbar(erroReturn, { variant: 'error' });
      console.log(error);
    }
  }, [error, enqueueSnackbar]);

  //{ Publicações Oficiais }
  const { data: dataPublicacoes, isFetching: isFetchingPublicacoes, isLoading: isLoadingPublicacoes, error: errorPublicacoes } = useGetUltimasPublicacoesPublicQuery();

  useEffect(() => {
    if (!dataPublicacoes) return;
    setUltimasPublicacoes(dataPublicacoes.results);
  }, [dataPublicacoes]);

  useEffect(() => {
    if (errorPublicacoes) {
      enqueueSnackbar('Erro ao carregar as publicações.', { variant: 'error' });
      const erroReturn: string = formatErrorMessage(errorPublicacoes);
      enqueueSnackbar(erroReturn, { variant: 'error' });
      console.error(errorPublicacoes);
    }
  }, [errorPublicacoes, enqueueSnackbar]);

  //{ Licitaçoes  }
  const { data: dataLicitacoes, isFetching: isFetchingLicitacoes, isLoading: isLoadingLicitacoes, error: errorLicitacoes } = useGetUltimasLicitacoesPublicQuery();

  useEffect(() => {
    if (!dataLicitacoes) return;
    setUltimasLicitacoes(dataLicitacoes.results);
  }, [dataLicitacoes]);

  useEffect(() => {
    if (errorLicitacoes) {
      enqueueSnackbar('Erro ao carregar as Licitações.', { variant: 'error' });
      const erroReturn: string = formatErrorMessage(errorLicitacoes);
      enqueueSnackbar(erroReturn, { variant: 'error' });
      console.error(errorLicitacoes);
    }
  }, [errorLicitacoes, enqueueSnackbar]);

  return (
    <Box id="main" sx={{ width: '100%' }}>
      <Box id="destaques">
        <NoticiaViewCarrossel noticiaAnexos={noticias} isFetching={isFetching} />
      </Box>
      <Box sx={{ mt: 5 }} id="ultimas-noticias">
        <NoticiaHomeCardForm noticias={ultimasNoticias} isFetching={isFetching} />
      </Box>
      {/* Divider entre Notícias e Publicações Oficiais */}
      <Box sx={{ my: 5 }}>
        <Divider sx={{ borderColor: '#EBEBEB' }} />
      </Box>
      <Box sx={{ mt: 5 }} id="ultimas-noticias">
        <PublicacaoOficialHomeCardForm publicacoes={ultimasPublicacoes} isFetching={isFetchingPublicacoes} />
      </Box>

      <Box sx={{ my: 5 }}>
        <Divider sx={{ borderColor: '#EBEBEB' }} />
      </Box>

      <Box sx={{ mt: 5 }} id="ultimas-noticias">
        <LicitacaoHomeCardForm licitacoes={ultimasLicitacoes} isFetching={isFetchingLicitacoes} />
      </Box>
    </Box>
  );
}
